import { FC } from 'react';
import Avatar from 'src/common/components/Avatar';
import type { UserAvatar } from 'src/common/components/Avatar';
import UniversalLink from 'src/common/components/UniversalLink';
import Rating from 'src/common/components/Rating';
import Typography from 'src/common/components/Typography';
import styles from './StaticReview.module.scss';

export type StaticReviewProps = {
  title: string;
  rating: number;
  review: string;
  user: UserAvatar;
  url: string;
};

const StaticReview: FC<StaticReviewProps> = ({
  title,
  rating,
  review,
  user,
  url,
}) => (
  <div className={styles.root}>
    <UniversalLink
      href={url}
    >
      <div className={styles.title}>
        <Typography size="body-l" type="p">
          {title}
        </Typography>
      </div>
    </UniversalLink>
    <div className={styles.review}>
      <Rating
        rating={rating}
        theme="midnight01"
      />
      <Typography
        size="body-l"
        type="p"
      >
        {review}
      </Typography>
    </div>
    <div className={styles.author}>
      <Avatar user={user} />
      <div className={styles.name}>
        <Typography size="body-l" type="p">
          {user.first_name}
        </Typography>
      </div>
    </div>
  </div>
);

export default StaticReview;
